<template>
	<div>
		<draggable :group="'step-' + id" :list="zones" class="list-group">
			<div v-for="(zone, idx) in zones" :key="idx">
				<span v-if="(zone.level == 0 && level == 0) || level != 0">
					<span v-for="i in zone.level" :key="i"
						>&nbsp;&nbsp;&nbsp;&nbsp;</span
					>
					<b-button
						:style="
							'color:black; text-align: left !important;font-weight:' +
							(zone.id == view ? 'bold' : 'normal')
						"
						variant="link"
						@click="send_select(zone.id)"
						>{{
							zone.description
								? zone.description.substring(0, 30)
								: (zone.name
										? zone.name.substring(0, 30)
										: "zone " + idx) +
								  (zone.name && zone.name.length > 30
										? "..."
										: "")
						}} </b-button
					><i class="fas fa-plus" @click="addZone(zone.id)"></i>
					<document_extraction_tree
						v-if="zone.zones.length > 0"
						:level="level + 1"
						:zones="zone.zones"
						:view="view"
						@select="select_child"
						@add="
							add_child(zone.id, ...arguments)
						"></document_extraction_tree>
				</span>
			</div>
		</draggable>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";
	import { JSONEditor } from "@json-editor/json-editor";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	export default {
		name: "document_extraction_tree",
		components: {
			draggable,
		},
		props: {
			zones: {
				default: () => {},
			},
			level: {
				default: 0,
			},
			view: {
				default: "",
			},
		},
		data() {
			return {
				id: uniqueId(""),
			};
		},
		methods: {
			async save() {
				var data = {};

				return data;
			},
			async load(data) {},
			async send_select(id) {
				this.$emit("select", id);
			},
			async select_child(id) {
				this.$emit("select", id);
			},
			async add_child(id, level, ids) {
				var arr = ids;
				arr.unshift(id);
				this.$emit("add", level, arr);
			},
			async addZone(id) {
				this.$emit("add", this.level + 1, [id]);
			},
		},
		mounted: async function () {},
	};
</script>

<style></style>
